/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessToken } from '../models/AccessToken';
import type { EmailOtpCodeFingerprintPayload } from '../models/EmailOtpCodeFingerprintPayload';
import type { EmailPayload } from '../models/EmailPayload';
import type { TokenPayload } from '../models/TokenPayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Initiate Login
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static initiateLoginApiPublicAuthInitiateLoginPost(
        requestBody: EmailPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/auth/initiate-login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Complete Login
     * @param requestBody
     * @returns AccessToken Successful Response
     * @throws ApiError
     */
    public static completeLoginApiPublicAuthCompleteLoginPost(
        requestBody: EmailOtpCodeFingerprintPayload,
    ): CancelablePromise<AccessToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/auth/complete-login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Resend Otp
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static resendOtpApiPublicAuthResendOtpPost(
        requestBody: EmailPayload,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/auth/resend-otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Google Login
     * @param requestBody
     * @returns AccessToken Successful Response
     * @throws ApiError
     */
    public static googleLoginApiPublicAuthGoogleLoginPost(
        requestBody: TokenPayload,
    ): CancelablePromise<AccessToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/auth/google-login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Apple Login
     * @param requestBody
     * @returns AccessToken Successful Response
     * @throws ApiError
     */
    public static appleLoginApiPublicAuthAppleLoginPost(
        requestBody: TokenPayload,
    ): CancelablePromise<AccessToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/public/auth/apple-login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
                423: `Locked`,
            },
        });
    }
    /**
     * Logout
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logoutApiAuthLogoutPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/logout',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Refresh Token
     * @returns AccessToken Successful Response
     * @throws ApiError
     */
    public static refreshTokenApiAuthRefreshPost(): CancelablePromise<AccessToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/auth/refresh',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }
}
